import { apiFetch } from '@/api/apiFetch';
import type { EProductImageType } from '@/domain/product/EProductImageType';
import type { EProductFileField } from '@/domain/product/EProductFileField';

async function postProductImage(file: File, _productId: string, _type: EProductImageType): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiFetch('/product-files', { method: 'POST', body: formData });
    const data: { id: string } = await response.json();
    return data.id;
}

async function fetchProductImage(imageUUID: string): Promise<Blob> {
    const response = await apiFetch(`/product-files/${imageUUID}`);
    return response.blob();
}

async function deleteProductImage(productName: string, field: EProductFileField): Promise<void> {
    await apiFetch(`/products/${productName}/files/${field}`, { method: 'DELETE' });
}

export { deleteProductImage, fetchProductImage, postProductImage };
